export const EXPEDITE_CHOICE_MAPPER = {
  instant: 2,
  sameDay: 1,
  standard: 0,
} as const;

export const EXPEDITE_CHOICE_TO_SPEED: Record<
  number,
  "instant" | "sameDay" | "standard"
> = {
  [EXPEDITE_CHOICE_MAPPER.instant]: "instant",
  [EXPEDITE_CHOICE_MAPPER.sameDay]: "sameDay",
  [EXPEDITE_CHOICE_MAPPER.standard]: "standard",
};

export const EXPEDITE_OPTION_TO_CHOICE = {
  "": EXPEDITE_CHOICE_MAPPER.standard,
  sameDay: EXPEDITE_CHOICE_MAPPER.sameDay,
  fedNow: EXPEDITE_CHOICE_MAPPER.instant,
  fastest: EXPEDITE_CHOICE_MAPPER.instant,
} as const;

export const MAX_EXPEDITE_CHOICE = EXPEDITE_CHOICE_MAPPER.instant;

export type ExpediteSpeed = "instant" | "sameDay" | "standard" | "";
export type ExpediteOption = "fastest" | "sameDay" | "fedNow" | "";

type ResolveExpediteArgs = {
  // what the user asked for
  chosenExpediteOption?: ExpediteOption;
  // what this row is actually capable of
  speedStatus?: ExpediteSpeed;
  // the ceiling imposed by a template's max_expedite_choice, if any
  maxExpediteChoice?: number;
};

// resolves expedite_choice for each payment row
// returns 0 when user has not opted in for expedite,
// which is what makes an unchecked expedite card explicitly send standard
export const resolveExpediteChoice = ({
  chosenExpediteOption = "",
  speedStatus = "",
  maxExpediteChoice = MAX_EXPEDITE_CHOICE,
}: ResolveExpediteArgs): number =>
  Math.min(
    EXPEDITE_OPTION_TO_CHOICE[chosenExpediteOption],
    speedStatus ? EXPEDITE_CHOICE_MAPPER[speedStatus] : 0,
    maxExpediteChoice,
  );

// used to display speeds. returns "" when user has not opted into expediting,
// which callers treat as "show eligibility copy rather than a chosen speed"
export const resolveExpediteSpeed = (
  args: ResolveExpediteArgs,
): ExpediteSpeed => {
  if (!args.chosenExpediteOption || !args.speedStatus) return "";
  return EXPEDITE_CHOICE_TO_SPEED[resolveExpediteChoice(args)] ?? "";
};
